import { Link } from "react-router-dom";
import { slide as Menu } from "react-burger-menu";
import { Dropdown } from "rsuite";
import NotificationComponent from "../Notifications/Notifications";
import { NotificationBadge, UserBadge } from "../Notifications/Notifications";
import { DarkMode } from "../../styles/ThemePallette";

const HamburgerMenu = ({
  showNotifications,
  setNotifications,
  isAdmin,
  adminItems,
  userItems,
  dropdownForRole,
  navItem,
  notificationCount,
  getNotifications,
  handleReadNotification,
  activeUsersSummary,
  setActiveModal,
  hasAccessClientProfile,
  canEditContract,
  setShowContractForm,
}) => {
  const statsDropdownItems = [
    { path: "/stats/table", label: "Table" },
    { path: "/stats/graph", label: "Graph" },
    { path: "/stats/expense", label: "Expense" },
    { path: "/stats/progress", label: "Progress Report" },
  ];

  if (isAdmin) {
    statsDropdownItems.push({ path: "/recurring-report", label: "Recurring Report" });
  }

  return (
    <Menu className="menu-bar" right width={"35%"}>
      <div className="image-wrapper-burger mb-2 me-2">
        <img
          className="logo-image w-10"
          height={10}
          src="../images/headerlogo.png"
          alt="TPE Logo"
        />
      </div>
      <NotificationComponent {...{ showNotifications, setNotifications }} />

      <ul className="navbar-nav me-auto">
        {navItem(`/contracts`, "Contracts", "mb-2 nav-item-contracts")}

        {/* Stats Dropdown */}
        <li className="nav-item mb-2">
          <Dropdown
            title="Stats"
            className="nav-link btn !tw-text-sm tw-py-2 nav-item-stats"
            placement="bottomStart"
          >
            {statsDropdownItems.map((item, index) => (
              <Dropdown.Item key={index} as={Link} to={item.path}>
                {item.label}
              </Dropdown.Item>
            ))}
          </Dropdown>
        </li>

        {/* Customers */}
        {hasAccessClientProfile && navItem(`/customers`, "Customers", "mb-2 nav-item-customers")}

        {/* Vendors */}
        {navItem(`/vendors`, "Vendors", "mb-2 nav-item-vendors")}

        {/* Add Event */}
        {canEditContract && (
          <li className="nav-item mb-2">
            <span
              className="nav-link btn !tw-text-sm tw-py-2 nav-item-add-event"
              onClick={() => setShowContractForm && setShowContractForm(1)}
              style={{ cursor: "pointer" }}
            >
              Add Event
            </span>
          </li>
        )}
      </ul>

      <div>
        <div className="d-flex mt-2">
          <NotificationBadge
            {...{
              getNotifications,
              handleReadNotification,
              setNotifications,
              notificationCount,
            }}
          />
          <UserBadge {...{ activeUsersSummary, setActiveModal }} />
          <div className="nav-link nav-item-color">
            <DarkMode />
          </div>
        </div>
        <div className="mt-2 mb-2 d-flex align-items-center">
          {isAdmin
            ? dropdownForRole(adminItems)
            : dropdownForRole(userItems)}
        </div>
      </div>
    </Menu>
  );
};

export default HamburgerMenu;
